import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
// import { useEffect } from "react";
// import { useWebSocketStore } from "@/lib/websocket";
import { Notification } from "@/lib/types/notifications";
import { useNotificationStore } from "@/store/notifications";
// import { apiClient } from "@/lib/api/client";

export const NOTIFICATIONS_QUERY_KEY = ["notifications"];

async function fetchNotifications(): Promise<Notification[]> {
  // const response = await apiClient.get("/notifications");
  // if (!(response.status === 200)) {
  //   throw new Error("Failed to fetch notifications");
  // }
  // return response.data;
  return [];
}

async function markAsRead(id: string): Promise<void> {
  const response = await fetch(`/notifications/${id}/read`, {
    method: "POST",
  });
  if (!response.ok) {
    throw new Error("Failed to mark notification as read");
  }
}

const EMPTY_NOTIFICATIONS: Notification[] = [];

export function useNotifications() {
  const queryClient = useQueryClient();
  const store = useNotificationStore();
  const { data, isLoading, error } = useQuery({
    queryKey: NOTIFICATIONS_QUERY_KEY,
    queryFn: fetchNotifications,
  });

  const markAsReadMutation = useMutation({
    mutationFn: markAsRead,
    onSuccess: (_, id) => {
      store.markAsRead(id);
      queryClient.invalidateQueries({
        queryKey: NOTIFICATIONS_QUERY_KEY,
      });
    },
  });

  return {
    notifications: data ?? EMPTY_NOTIFICATIONS,
    isLoading,
    error,
    markAsRead: markAsReadMutation.mutate,
    markAllAsRead: store.markAllAsRead,
    unreadCount: store.unreadCount,
  };
}
